import { FormControl } from '@angular/forms';
var FcTextAreaInputComponent = /** @class */ (function () {
    function FcTextAreaInputComponent() {
        this.requiredMark = false;
        this.maxLength = null;
    }
    return FcTextAreaInputComponent;
}());
export { FcTextAreaInputComponent };
